import { FC, useEffect, useRef, useState } from 'react';
import styles from '../index.module.less';
import V2AMap from '@/common/components/Map/V2AMap';
import { useMethods } from '@lhb/hook';
import IconFont from '@/common/components/IconFont';

/**
 * @Description 踩点记录详情地图
 */
const FootPrintMap:FC<{detail}> = ({ detail }) => {
  const [mapIns, setMapIns] = useState<any>(null);
  const hoverMarkerRef = useRef<any>(null);

  useEffect(() => {
    if (detail?.lat && detail?.lng && mapIns) {
      methods.drawPoint();
    }
  }, [detail, mapIns]);

  const methods = useMethods({
    mapLoadedHandle(mapIns) {
      setMapIns(mapIns);
    },
    handleLocate() {
      if (detail?.lat && detail?.lng) {
        mapIns && mapIns.setZoomAndCenter(16, [+detail.lng, +detail.lat], false, 200);
      }
    },
    drawPoint() {
      const { lat, lng, address, createdAt } = detail;
      const marker = new window.AMap.Marker({
        position: [+lng, +lat],
        map: mapIns,
        zIndex: 1,
        content: `<img class="mapMarkerIcon" src="${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/icon_flag@2x_2.png"/>`,
        offset: new window.AMap.Pixel(-12, -15)
      });
      marker.on('mouseover', () => {
        const hoverMarker = new window.AMap.Marker({
          position: [+lng, +lat],
          offset: new window.AMap.Pixel(-109, 17),
          content: `<div class="mapMarkerCard">
            <div class="cardTitle">${address}</div>
            <div class="cardTime">${createdAt}</div>
          </div>`,
        });
        mapIns.add(hoverMarker);
        hoverMarkerRef.current = hoverMarker;
      });
      marker.on('mouseout', () => {
        if (hoverMarkerRef.current) {
          mapIns.remove(hoverMarkerRef.current);
          hoverMarkerRef.current = null;
        }
      });
      mapIns.add(marker);
      methods.handleLocate();
    },
    handleMarkerHover() {

    }
  });
  return (
    <div className={styles.mapWrapper}>
      <V2AMap
        mapOpts={{
          mapStyle: 'amap://styles/whitesmoke'
        }}
        loaded={methods.mapLoadedHandle}
      />

      <div className={styles.toolBottomBar}>
        <IconFont
          iconHref='asset-pc-gongjuxiang_daba1'
          className='c-666 fs-10'
          onClick={methods.handleLocate}
        />
      </div>


    </div>
  );
};

export default FootPrintMap;
